import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, ValidatorFn, AsyncValidatorFn, FormBuilder, AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import { Subject } from 'rxjs';
import { OperazioniDisponibili, Soggetto, FirRemoto, OutputEventCampiInit, OutputEventCampiStatus, OutputEventCampiErrors, OutputEventCampiValue } from '../../interfaces';
import CustomStore from 'devextreme/data/custom_store';
import { Apiservice } from '../../../../services/api.service';
import { takeUntil } from 'rxjs/operators';
import { alert } from 'devextreme/ui/dialog';
import { DocumentTask, FirDigitaliTransactionService, TransactionStateMap } from '../../../../services/fir-digitali-transaction.service';

@Component({
  selector: 'app-aggiungi-nuovo-destinatario',
  templateUrl: './aggiungi-nuovo-destinatario.component.html',
  styleUrls: ['./aggiungi-nuovo-destinatario.component.css']
})
export class AggiungiNuovoDestinatarioComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() operazioniDisponibili: OperazioniDisponibili
  @Input() soggetto: Soggetto
  @Input() group: Array<"NuovoDestinatario">;
  @Input() firRemoto: FirRemoto
  @Input() sezioneGroup: string
  @Input() meta: { [key: string]: boolean } = {}
  @Output() initGroup = new EventEmitter<OutputEventCampiInit>();
  @Output() statusChange = new EventEmitter<OutputEventCampiStatus>();
  @Output() errorsChange = new EventEmitter<OutputEventCampiErrors>();
  @Output() valueChange = new EventEmitter<OutputEventCampiValue>();
  protected formGroups: FormGroup = this.fb.group({})
  protected currentGroup: string = ''
  // protected isDisabled: boolean = false
  protected fields: Record<string, {
    label: string;
    validators?: ValidatorFn[];
    asyncValidators?: AsyncValidatorFn[];
    disabled?: boolean;
    items?: {
      dataSource?: DataSource | any[];
      displayExpr?: string | ((item: any) => string);
      valueExpr?: string | ((item: any) => string);
    }
  }>
  private destroy$ = new Subject<void>();

  constructor(private readonly fb: FormBuilder, private readonly Apiservice: Apiservice, private readonly FirTransaction: FirDigitaliTransactionService) { }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngAfterViewInit(): void {
    console.log(this)
    this.initGroup.emit({
      name: 'onInit',
      value: this.formGroups.value,
      formGroups: this.formGroups,
      sezione: this.sezioneGroup,
      component: this, touched: this.isFormTouched()
    })
  }
  ngOnInit() {
    if (!this.group || !this.soggetto || !this.operazioniDisponibili || !this.firRemoto) alert('Errore', 'Attenzione');
    else {
      this.currentGroup = 'NuovoDestinatario';
      this.processFieldsMetadata();
      this.processFormGroup()
      this.formGroups.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.emitEvents());

      this.formGroups.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => {
          this.valueChange.emit({ name: 'valueChange', formGroups: this.formGroups, value: value, sezione: this.sezioneGroup, component: this, touched: this.isFormTouched() });
          this.emitEvents();
        });
      // this.FirTransaction.globalQueue$.pipe(takeUntil(this.destroy$)).subscribe({
      //   next: (next: DocumentTask[]) => {
      //     this.isDisabled = next.length > 0 ? next.some((task) => (task.status !== 'error' && task.status !== 'completed') ?
      //       this.group.includes(task.processId as any) : false) : false
      //   },
      // })
      // this.FirTransaction.state$.pipe(takeUntil(this.destroy$)).subscribe({
      //   next: (next: TransactionStateMap) => {
      //     this.isDisabled = next[this.firRemoto.dati_partenza.numero_fir] ?
      //       (next[this.firRemoto.dati_partenza.numero_fir].status !== 'error' && next[this.firRemoto.dati_partenza.numero_fir].status !== 'completed') ?
      //         next[this.firRemoto.dati_partenza.numero_fir].listTask.some((val) => (val.status !== 'completed' && val.status !== 'error') ? this.group.includes(val.processId as any) : false)
      //         : false : false
      //   },
      // })
    }
  }
  hasError(actionKey: string, fieldKey: string): boolean {
    const group = this.getForm(actionKey);
    if (!group) return false;
    const control = group.get(fieldKey);
    if (!control) return false;
    if (!control.touched) return false;
    return control.invalid;
  }

  getForm(key: string): FormGroup | null {
    if (!this.formGroups.get(key)) return null
    return this.formGroups.get(key) as FormGroup;
  }
  getValue(key: string, field: string): FormGroup | null {
    if (!this.formGroups.get(key)) return null
    const group = this.formGroups.get(key) as FormGroup;
    const campo = group.get(field)
    if (!campo) return null
    return campo.value;
  }
  onDxChange(group, field, event) {
    console.log(event)
    console.log(field)
    console.log(group)
    const gruppo = this.formGroups.get(group)
    if (!gruppo) return
    const control = gruppo.get(field)
    if (!control) return
    control.setValue(event.value)
    gruppo.updateValueAndValidity()


    if (field === 'destinatario') {
      this.onDestinatarioChange(event.value);
    }
    if (field === 'unita_locale') {
      this.onUlChange(event.value);
    }
  }

  //! -------------------------------------------------------------------------
  private isFormTouched(): boolean {
    for (const actionKey of this.group) {
      if (this.meta[actionKey] === false) continue;
      const group = this.getForm(actionKey);
      if (!group) continue;
      const controls = Object.entries(group.controls);
      const values = controls.map(([_, ctrl]) => (ctrl.value || '').toString().trim());
      const hasValue = values.some(v => v !== '');
      if (hasValue) return true
    }
    return false;
  }

  private onDestinatarioChange(dest: any) {
    if (dest && dest.id) {
      this.fields['unita_locale'].disabled = false
      this.fields['unita_locale'].items.dataSource = this.createDataSource(`Sede/${dest.id}`, 'id', 'descrizione', '', 10, true, dest)
    } else {
      this.fields['unita_locale'].disabled = true
      this.fields['unita_locale'].items.dataSource = []
    }
    const group = this.getForm('NuovoDestinatario');
    group.get('unita_locale').setValue(null);
  }
  private onUlChange(ul: any) {
    if (ul && ul.id) {
      this.fields['autorizzazione'].disabled = false
      this.fields['autorizzazione'].items.dataSource = this.createDataSource(`Autorizzazione/${ul.id}`, 'id', ['descrizione', 'numero'], '', 10, true, ul)
    } else {
      this.fields['autorizzazione'].disabled = true
      this.fields['autorizzazione'].items.dataSource = []
    }
    const group = this.getForm('NuovoDestinatario');
    group.get('autorizzazione').setValue(null);
  }

  private emitEvents(): void {
    const messages = []
    for (const actionKey of this.group) {
      if (this.meta[actionKey] === false) continue;
      const group = this.getForm(actionKey);
      if (!group) continue;

      const value = group.getRawValue();
      for (const field of Object.keys(value)) {
        const msg = this.getErrorMessage(actionKey, field);
        if (msg) messages.push(msg);
      }
    }

    const status = this.formGroups.status === 'VALID' ? 'VALID' : 'INVALID';
    this.statusChange.emit({ name: 'statusChange', status, formGroups: this.formGroups, sezione: this.sezioneGroup, component: this, touched: this.isFormTouched() });
    this.errorsChange.emit({ name: 'errorsChange', errors: messages, formGroups: this.formGroups, sezione: this.sezioneGroup, component: this, touched: this.isFormTouched() });
  }

  private getErrorMessage(actionKey: string, field: string): string | null {
    const group = this.getForm(actionKey);
    const control = group.get(field);
    if (!control || !control.errors) return null;
    const errors = control.errors;
    const fallbackMessages: Record<string, (err: any) => string> = {
      required: () => `Campo ${this.fields[field].label} obbligatorio`,
      minlength: err => `Campo ${this.fields[field].label} minimo ${err.requiredLength} caratteri`,
      maxlength: err => `Campo ${this.fields[field].label} massimo ${err.requiredLength} caratteri`,
      min: err => `Campo ${this.fields[field].label} valore minimo ${err.min}`,
      max: err => `Campo ${this.fields[field].label} valore massimo ${err.max}`,
      pattern: () => `Campo ${this.fields[field].label} non valido`,
      custom: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
      async: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
    };
    for (const key of Object.keys(errors)) {
      const err = errors[key];
      if (fallbackMessages[key]) return fallbackMessages[key](err);
    }
    return `Campo non valido`;
  }

  private dynamicGroupActivation(
    validatorsMap: Record<string, ValidatorFn[]>
  ): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      if (!(group instanceof FormGroup)) return null;
      const controls = Object.entries(group.controls);
      const values = controls.map(([_, ctrl]) => (ctrl.value || '').toString().trim());
      const hasValue = values.some(v => v !== '');
      for (const [field, ctrl] of controls) {
        const originalValidators = validatorsMap[field] || [];
        if (hasValue) {
          ctrl.setValidators(originalValidators);
        } else {
          ctrl.clearValidators();
        }
        ctrl.updateValueAndValidity({ emitEvent: false, onlySelf: true });
      }
      return null;
    };
  }

  private processFormGroup() {
    for (const key of this.group) {
      const subGroup = this.fb.group({});
      this.formGroups.addControl(key, subGroup);
      this.buildForm(subGroup, key);
    }
  }

  private buildForm(subGroup: FormGroup, operazione: string) {
    subGroup.addControl('destinatario', this.fb.control(null));
    subGroup.addControl('unita_locale', this.fb.control(null));
    subGroup.addControl('autorizzazione', this.fb.control(null));
    subGroup.addControl('attivita', this.fb.control(null));
    const validatorsMap: Record<string, ValidatorFn[]> = {};
    for (const fieldName of Object.keys(subGroup.controls)) {
      validatorsMap[fieldName] = this.fields[fieldName].validators || [];
    }
    if (this.meta[operazione] === false) return;
    else return subGroup.setValidators(this.dynamicGroupActivation(validatorsMap));
  }

  private processFieldsMetadata() {
    this.fields = {
      destinatario: {
        label: 'Destinatario',
        validators: [Validators.required],
        items: {
          dataSource: this.createDataSource('Soggetto', 'id', 'ragioneSociale', 'TipoAttivita=S', 10, false, undefined),
          displayExpr: 'ragioneSociale',
          valueExpr: null,
        },
      },
      unita_locale: {
        label: 'U.L',
        validators: [Validators.required],
        disabled: true,
        items: {
          dataSource: [],
          displayExpr: 'descrizione',
          valueExpr: null,
        }
      },
      autorizzazione: {
        label: 'Autorizzazione',
        validators: [Validators.required],
        disabled: true,
        items: {
          dataSource: [],
          displayExpr: (item) => item ? `${item.descrizione} - (${item.numero})` : '',
          valueExpr: null,
        }
      },
      attivita: {
        label: 'Op. Smalt/Rec.',
        validators: [Validators.required],
        items: {
          dataSource: this.createDataSource('OperazioneSmaltimento', 'id', 'id', '', 10, false, undefined),
          displayExpr: 'id',
          valueExpr: 'id',
        }
      },
    }
  }

  private createDataSource(
    endpoint: string,
    keyField: string = 'id',
    displayField: string | string[] = 'id',
    filterPart: string = '',
    pageSize: number = 10,
    isPreCheck: boolean = false,
    chechkValue?: any,
    transformFn?: (items: any[]) => any[],
  ) {
    return new DataSource({
      store: new CustomStore({
        key: keyField,
        load: async (loadOptions: any) => {
          if (isPreCheck && !chechkValue) return { data: [], totalCount: 0 };
          try {
            const skip = loadOptions.skip || 0;
            const take = loadOptions.take || pageSize;
            let currentFilterPart = '&' + filterPart.replace('?', '');
            if (loadOptions.searchValue && loadOptions.searchValue.trim() !== '') {
              const s = loadOptions.searchValue.trim().toLowerCase();

              if (!Array.isArray(displayField)) {
                if (currentFilterPart.includes('$filter=')) {
                  currentFilterPart = currentFilterPart.replace(
                    '$filter=',
                    `$filter=contains(tolower(${displayField}), '${s}') and `
                  );
                } else {
                  currentFilterPart += `&$filter=contains(tolower(${displayField}), '${s}')`;
                }
              } else {
                displayField.forEach((val) => {
                  if (currentFilterPart.includes('$filter=')) {
                    currentFilterPart = currentFilterPart.replace(
                      '$filter=',
                      `$filter=contains(tolower(${val}), '${s}') and `
                    );
                  } else {
                    currentFilterPart += `&$filter=contains(tolower(${val}), '${s}')`;
                  }
                })
              }
            }
            const url =
              `${endpoint}?$skip=${skip}&$top=${take}&$count=true` +
              currentFilterPart;
            const res: any = await this.Apiservice.GetApi(url);
            let items = res.items || [];
            if (transformFn) items = transformFn(items);
            return {
              data: items,
              totalCount: res.totalCount || 0,
            };
          } catch (e) {
            console.error("Errore load generic", e);
            throw e;
          }
        },

        byKey: async (key: any) => {
          if (isPreCheck && !chechkValue) return null;
          if (key === null || key === undefined || key === '' || key === 0) return null;
          try {
            const url = (() => {
              const partKey = typeof key === 'string' ? `'${key}'` : `${key}`
              const filters: string[] = [];
              const m = filterPart.match(/\$filter=(.*)/);
              if (m) filters.push(`(${m[1]})`);
              filters.push(`${keyField} eq ${partKey}`);
              filterPart = filterPart.split('$filter=')[0].replace(/&$/, '')
              return `${endpoint}?${filterPart}&$filter=${filters.join(' and ')}`
            })();
            const res: any = await this.Apiservice.GetApi(url);
            let items = res.items || [];
            if (transformFn) items = transformFn(items);
            return items[0] || null;
          } catch (e) {
            console.error("Errore byKey generic", e);
            throw e;
          }
        },
      }),
      paginate: true,
      pageSize,
      searchExpr: displayField,
    });
  }
}
